export default __webpack_public_path__ + "static/media/joomla-negative.1c6d46bc.svg";